<p-accordion [multiple]="true">
    <p-accordionTab header="Header I" [selected]="true">
      <div class="p-grid">
        <p-card class="p-col-6">
          <p-chart type="pie" (onDataSelect)="selectPieData($event)" [data]="template2Pie" [height]="250"></p-chart>
        </p-card>
        <p-card class="p-col-6">
          <p-chart type="line" [data]="template2Line" [height]="250"></p-chart>
        </p-card>
      </div>
    </p-accordionTab>
    <p-accordionTab header="Header II">
      <div class="p-grid">
        <p-card class="p-col-4">
          <p-chart type="doughnut" (onDataSelect)="selectDoughnutData($event)" [data]="template3Doughnut" [height]="250"></p-chart>
        </p-card>
        <p-card class="p-col-4">
          <p-chart type="polarArea" [data]="template3Polar" [height]="250"></p-chart>
        </p-card>
        <p-card class="p-col-4">
          <p-chart type="radar" [data]="template3Radar" [height]="250"></p-chart>
        </p-card>
      </div>
    </p-accordionTab>
    <p-accordionTab header="Header III">
      <div class="p-grid">
        <p-card class="p-col-12">
          <p-chart type="bar" [data]="template1Bar" [height]="250"></p-chart>
        </p-card>
      </div>
    </p-accordionTab>
  </p-accordion>


  <p-dialog header="Doughnut Details" [(visible)]="displayDoughnutDetail" [modal]="true" [style]="{width: '60vw'}">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-4 p-md-2">
            <p><strong>Lable: </strong></p>
        </div>
        <div class="p-col-8 p-md-4">
            <p>{{selectedDoughnutLabel}}</p>
        </div>
        <div class="p-col-4 p-md-2">
          <p><strong>Value: </strong></p>
        </div>
        <div class="p-col-8 p-md-4">
          <p>{{selectedDoughnutData}}</p>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="displayDoughnutDetail=false;" label="Cancel" class="p-button-secondary"></button>
      <button pButton label="Save"></button>
    </ng-template>
  </p-dialog>
